// extracted by mini-css-extract-plugin
export default {"input":"Page14_input__7qKQM","danmaku":"Page14_danmaku__cs+uy","lane":"Page14_lane__HGq+x","item":"Page14_item__hRapu"};